export default "__VITE_ASSET__Xe$SyOfv__"